import React from 'react'
import ContactForm from '../components/ContactForm/contactform'

const ContactMe = () => {
  return (
    <div>
        <ContactForm />
    </div>
  )
}

export default ContactMe
